import qs from "qs";
import toastr from "toastr";
import ajax from "@/common/ajax";

export default class EntityAdministrationService {
    constructor() {
        this.url = "/api/EntityAdministration/";
    }

    getObjects(request) {
        return ajax.get(this.url + "GetObjects", qs.stringify(request, {
            arrayFormat: "indices",
            allowDots: true
        })).fail(response => toastr.error(response.responseJSON.message));
    }

    createEditObject(request) {
        return ajax.post(this.url + "CreateEditObject", request);
    }

    deleteObject(request) {
        return ajax.post(this.url + "DeleteObject", request);
    }
}